/*
In content navigation component
*/
import Blue from '~/core';

new Blue({
  name: 'Nav',
  selector: '.nav',
  setup(nav) {
    const trigger = nav.querySelector('.nav__title');
    const content = nav.querySelector('.nav__menu');
    const items = nav.querySelectorAll('.nav__item');

    const toggle = new this.$toggle({
      trigger,
      content,
      props: ['height', 'visibility'],
      externalEvents: true,
    });

    this.$addEvents(trigger, 'click.stop.prevent enter.stop.prevent', () => {
      if (!this.$screen.lg.matches) toggle.toggle();
    });

    items.forEach(item => {
      const subTrigger = item.querySelector('.nav__link');
      const subContent = item.querySelector('.nav__sub-menu');
      const relations = [];

      if (subContent) {
        const subToggle = new this.$toggle({
          trigger: subTrigger,
          content: subContent,
          props: ['height', 'visibility', 'opacity'],
          relations,
        });
        relations.push(subToggle);
      }
    });
  },
});
